export default __webpack_public_path__ + "static/media/property-gallery1.3992a9ff.webp";